import { useState } from "react";
import { toast } from "sonner";
import PageShell from "@/components/PageShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Mail, MapPin, MessageSquare } from "lucide-react";

export default function Contact() {
  const [sending, setSending] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    setSending(true);
    setTimeout(() => {
      setSending(false);
      toast.success("Mesajınız alındı. En kısa sürede dönüş yapacağız.");
      e.target.reset();
    }, 800);
  };
  return (
    <PageShell title="İletişim" subtitle="Sorularınız için bize ulaşın. Ekibimiz size yardımcı olmaktan memnuniyet duyar.">
      <div className="grid md:grid-cols-2 gap-10">
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <div>
            <Label className="text-sm">Ad Soyad</Label>
            <Input required data-testid="contact-name" className="mt-1.5" placeholder="Adınız" />
          </div>
          <div>
            <Label className="text-sm">E-posta</Label>
            <Input required type="email" data-testid="contact-email" className="mt-1.5" placeholder="ornek@eposta.com" />
          </div>
          <div>
            <Label className="text-sm">Mesajınız</Label>
            <Textarea required data-testid="contact-message" className="mt-1.5 min-h-32" placeholder="Size nasıl yardımcı olabiliriz?" />
          </div>
          <Button type="submit" disabled={sending} data-testid="contact-submit" className="rounded-full">
            {sending ? "Gönderiliyor..." : "Mesaj Gönder"}
          </Button>
        </form>
        <div className="space-y-5">
          {[
            { icon: Mail, t: "E-posta", d: "destek@coinbuy.org" },
            { icon: MessageSquare, t: "Canlı Destek", d: "Panel üzerinden destek talebi oluşturabilirsiniz." },
            { icon: MapPin, t: "Konum", d: "İstanbul, Türkiye" },
          ].map((x) => (
            <div key={x.t} className="flex gap-4 rounded-2xl border border-border bg-card p-5">
              <span className="shrink-0 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <x.icon size={20} strokeWidth={1.5} />
              </span>
              <div>
                <h3 className="text-sm font-bold">{x.t}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{x.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
